
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { BillItemGroupTypes } from '@/enums/billItemGroupTypes';
import { KeyValuePair } from '@/models/keyValuePair';

export interface BillGroupSelectItem {
  groupType: BillItemGroupTypes; // 分類
  itemId: number; // 請求項目ID
  itemName: string; // 項目名
  nonTaxable: boolean; // 消費税対象外
}

@Component({})
export default class BillGroupSelect extends Vue {
  @Prop({ type: Number, required: true })
  public value!: number;

  @Prop({ type: Number, required: true })
  public groupType!: BillItemGroupTypes;

  @Prop({ type: Array, required: true })
  public items!: BillGroupSelectItem[];

  get localValue() {
    return this.value;
  }
  set localValue(value: number) {
    this.$emit('input', value);
  }

  get localItems(): Array<KeyValuePair<number, string>> {
    return this.items.reduce((list, item) => {
      if (item.groupType === this.groupType) {
        list.push({
          key: item.itemId,
          value: item.itemName,
        });
      }
      return list;
    }, new Array<KeyValuePair<number, string>>());
  }
}
